import humps from 'humps'

export default () => {
  let config = [];

  const setConfig = (newConfig) => {
    if (newConfig) {
      config = newConfig;
    }
  };

  const getNodeByKey = (key) => {
    return config.find((e) => e.currentField === key && e?.isNode);
  };

  const getNodeUnitByKey = (key) => {
    return config.find((e) => e.currentField === key && !e?.isNode);
  };

  const getPathFieldsByKey = (key) => {
    const path = [];
    const start = (k, isUnit) => {
      const n = isUnit ? getNodeUnitByKey(k) : getNodeByKey(k);
      if (n?.parentField) {
        start(n.parentField);
      }
      if (n?.currentField) {
        path.push(n.currentField);
      }
    };

    start(key, true);
    return path.reverse();
  };

  const create = (fields, value, source) => {
    const start = (fieldsArr, src) => {
      const tempFields = fieldsArr;
      const field = tempFields.pop();
      let result = {};
      if (tempFields.length > 0) {
        if (src) {
          let tempResult = {};
          if (src[field]) {
            tempResult = start(tempFields, src[field]);
          } else {
            tempResult = start(tempFields);
          }
          result = {
            ...src,
            [field]: tempResult,
          };
        } else {
          result = {
            [field]: start(tempFields),
          };
        }
      } else {
        if (src) {
          result = {
            ...src,
            [field]: value,
          };
        } else {
          result = {
            [field]: value,
          };
        }
      }

      return result;
    };

    const result = start(fields, source);
    return result;
  };

  const execute = (prop) => {
    let result = {};
    for (const [key, value] of Object.entries(prop)) {
      const deKey = humps.decamelize(key);
      if (value !== undefined && value !== '' && value !== 0) {
        const path = getPathFieldsByKey(deKey);
        if (path.length && path.length > 0) {
          result = create(path, value, result);
        }
      }
    }

    return result;
  };

  const convertToRequestProps = (props) => {
    let result;
    if (props.length) {
      result = props.map((e) => {
        return execute(e);
      });
    } else if (typeof props === 'object') {
      result = execute(props);
    }

    return result;
  };

  return {
    convertToRequestProps,
    setConfig,
  };
};
